import { render, staticRenderFns } from "./global-header-right.vue?vue&type=template&id=ce9ddc4c&"
import script from "./global-header-right.vue?vue&type=script&lang=js&"
export * from "./global-header-right.vue?vue&type=script&lang=js&"
import style0 from "./global-header-right.vue?vue&type=style&index=0&id=ce9ddc4c&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports